import { DollarSign } from 'lucide-react';

const TrinidadTobagoHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* NEXX Logo Section */}
      <div className="mb-6 animate-scale-in">
        <img 
          src="/lovable-uploads/52ecf367-6211-48aa-82c5-83c88558cc42.png" 
          alt="NEXX TELECOM LLC Logo" 
          className="h-16 md:h-20 mx-auto opacity-90 hover:opacity-100 transition-opacity duration-300"
        />
      </div>

      <div className="animate-fade-in" style={{ animationDelay: '0.2s' }}>
        <div className="flex items-center justify-center mb-3 animate-scale-in" style={{ animationDelay: '0.4s' }}>
          <span className="text-3xl mr-2 animate-bounce" style={{ animationDuration: '2s' }}>🇹🇹</span>
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 bg-gradient-to-r from-red-600 via-gray-900 to-black bg-clip-text text-transparent">
            US Residential Internet Solutions for Trinidad & Tobago
          </h1>
        </div>
      
        {/* Main Forex Message */}
        <div className="flex items-center justify-center mb-4 animate-slide-in-right" style={{ animationDelay: '0.6s' }}>
          <DollarSign className="h-6 w-6 text-red-600 mr-2" />
          <span className="text-xl text-gray-800 font-bold">No USD? No Problem! We Accept TTD</span>
          <DollarSign className="h-6 w-6 text-red-600 ml-2" />
        </div>
        
        {/* Compact Value Prop */}
        <div className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-red-100 via-white to-black/10 rounded-full mb-4 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 animate-fade-in border border-red-200" style={{ animationDelay: '0.8s' }}>
          <span className="text-lg animate-pulse">🚀</span>
          <span className="ml-2 font-bold text-gray-900">Bypass Forex Issues - Pay in Trinidad & Tobago Dollars</span>
        </div>
        
        {/* Customer Count */}
        <div className="text-center animate-fade-in" style={{ animationDelay: '1s' }}>
          <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-red-600 to-red-700 text-white rounded-full shadow-lg transform hover:scale-110 transition-all duration-300">
            <span className="text-sm animate-pulse">⭐</span>
            <span className="ml-2 font-bold text-sm">2,000+ Caribbean Customers</span>
          </div>
        </div>
        
        {/* Forex Subtext */}
        <div className="mt-4 text-gray-600 text-sm animate-fade-in" style={{ animationDelay: '1.2s' }}>
          <p>Skip the currency exchange hassle • Direct TTD pricing • Local payment solutions</p>
        </div>
      </div>
    </div>
  );
};

export default TrinidadTobagoHeader;